(function () {
  const money = c => (c / 100).toLocaleString(undefined, {style:'currency', currency: window.Shopify ? Shopify.currency.active : 'USD'});
  const all = s => Array.from(document.querySelectorAll(s));
  // Open the bag through the header's own control so the drawer redraws its
  // lines and count straight away, rather than showing a stale bag.
  const openDrawer = () => {
    const trigger = document.querySelector('[data-cart-open]');
    if (trigger) { trigger.click(); return; }
    const s = document.querySelector('[data-cart-scrim]');
    if (s) s.classList.add('open');
  };

  const inStock = c => c.dataset.available !== 'false';

  function roomTotal(body) {
    // The total counts what can actually be bought today.
    let sum = 0, live = 0;
    body.querySelectorAll('[data-piece]').forEach(c => {
      if (!inStock(c)) return;
      sum += Number(c.dataset.price || 0);
      live++;
    });
    const out = body.querySelector('[data-room-total]');
    if (out) out.textContent = money(sum);
    const add = body.querySelector('[data-add-room]');
    if (add) add.disabled = live === 0;
  }
  all('[data-room-body]').forEach(roomTotal);
  document.addEventListener('click', e => {
    const pill = e.target.closest('[data-mat-pill]');
    if (!pill) return;
    const group = pill.closest('[data-matpick]');
    group.querySelectorAll('[data-mat-pill]').forEach(b => {
      const on = b === pill;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    const card = pill.closest('[data-piece]');
    if (card) {
      card.dataset.variant = pill.dataset.variant;
      card.dataset.price = pill.dataset.price;
      card.dataset.available = pill.dataset.available || 'true';
      const shop = card.querySelector('[data-quick-shop]');
      if (shop) {
        const live = inStock(card);
        shop.classList.toggle('isgone', !live);
        shop.textContent = live ? (shop.dataset.shopLabel || 'Quick shop') : (shop.dataset.goneLabel || 'Sold out');
      }
      const price = card.querySelector('[data-piece-price]');
      if (price) price.textContent = money(Number(pill.dataset.price || 0));
      const body = card.closest('[data-room-body]');
      if (body) roomTotal(body);
      return;
    }
    const wrap = pill.closest('[data-opt-wrap]');
    if (wrap) {
      const opt = wrap.querySelector('[data-opt]');
      if (!opt) return;
      opt.dataset.variant = pill.dataset.variant;
      opt.dataset.price = pill.dataset.price;
      opt.dataset.available = pill.dataset.available || 'true';
      opt.classList.toggle('isgone', opt.dataset.available === 'false');
      const gone = opt.querySelector('[data-opt-gone]');
      if (gone) gone.hidden = opt.dataset.available !== 'false';
      const price = opt.querySelector('[data-opt-price]');
      if (price) price.textContent = money(Number(pill.dataset.price || 0));
      // If this option is the chosen one, re-run the page's own selection so the
      // summary and total pick up the new price: deselect, then select again.
      if (opt.classList.contains('on')) { opt.click(); opt.click(); }
    }
  });
  document.addEventListener('click', async e => {
    const add = e.target.closest('[data-add-room]');
    if (!add) return;
    const body = add.closest('[data-room-body]');
    if (!body) return;
    const items = [], missing = [];
    body.querySelectorAll('[data-piece]').forEach(c => {
      const id = Number(c.dataset.variant);
      if (!id) return;
      if (!inStock(c)) { missing.push(c.dataset.title || ''); return; }
      const at = items.findIndex(i => i.id === id);
      if (at > -1) items[at].quantity += 1; else items.push({id: id, quantity: 1});
    });
    const note = body.querySelector('[data-room-note]');
    const say = text => { if (note) { note.hidden = !text; note.textContent = text || ''; } };
    if (!items.length) {
      say(add.dataset.allGone || 'Every piece in this room is sold out.');
      return;
    }
    say('');
    add.disabled = true;
    const post = payload => fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(payload)
    });
    const titleOf = id => {
      const c = body.querySelector('[data-piece][data-variant="' + id + '"]');
      return c ? (c.dataset.title || '') : '';
    };
    try {
      // Shopify's cart add is all-or-nothing: if the batch is refused, add one at
      // a time so the pieces that can be bought still land in the bag.
      let added = items.length;
      let reason = '';
      const res = await post({items});
      if (!res.ok) {
        added = 0;
        for (const item of items) {
          const one = await post({items: [item]});
          if (one.ok) { added++; continue; }
          const why = await one.json().catch(() => null);
          if (why && (why.description || why.message) && !reason) reason = why.description || why.message;
          missing.push(titleOf(item.id));
        }
      }
      add.disabled = false;
      const names = missing.filter(Boolean);
      if (!added) {
        say(reason || add.dataset.allGone || 'Nothing in this room could be added.');
        return;
      }
      // Say what landed in the bag, and name anything that could not come along.
      let line = add.dataset.addedText || 'Available items added to your bag.';
      if (names.length) {
        const list = names.length === 1 ? names[0]
          : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
        const tpl = add.dataset.someGone || 'Sold out: [pieces].';
        line += ' ' + (tpl.indexOf('[pieces]') > -1 ? tpl.replace('[pieces]', list) : tpl + ' ' + list);
      }
      say(line);
      openDrawer();
    } catch (err) {
      add.disabled = false;
      say('The bag did not respond. Try again.');
    }
  });
})();
